import React, { useState, useRef, useEffect, Suspense,useContext } from "react";
import axios from "axios";
import {Link, useParams} from "react-router-dom";
import Gallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { BiHeart, BiSolidHeart, BiRupee } from "react-icons/bi";
import { PiShareFat, PiPlayCircleBold, PiPauseCircleBold, PiPersonSimpleRunBold, PiShoppingBagOpen } from "react-icons/pi";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { PiBathtub } from "react-icons/pi";
import { IoBedOutline, IoMapOutline, IoEyeOutline, IoTrashBinOutline, IoVolumeMedium, IoVolumeMute } from "react-icons/io5";
import { GiLift, GiGasStove } from "react-icons/gi";
import { FaSwimmingPool } from "react-icons/fa";
import { SiSpringsecurity } from "react-icons/si";
import { TbHealthRecognition, TbPlayFootball, TbParking } from "react-icons/tb";
import ReactAudioPlayer from 'react-audio-player';
import { MdOutlineLocalLaundryService, MdBathroom } from "react-icons/md";
import { CgGym } from "react-icons/cg";
import OwlCarousel from "react-owl-carousel3";
import { GoChevronRight, GoChevronLeft } from "react-icons/go";
import PropertyBox from "../home/propertyBox";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { RiCloseLargeFill } from "react-icons/ri";
import { BsStars } from "react-icons/bs";
import { FaChevronRight } from "react-icons/fa6";
import { MdFileCopy, MdHomeWork, MdWhatsapp } from "react-icons/md";
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import { mediaUrl,baseURL } from '../../axiosInterceptor/axiosInterceptorC';
import { LoginPopupContext } from '../../loginpopup/LoginPopupContext'
import { FiCopy } from "react-icons/fi";
import { GrStepsOption } from "react-icons/gr";
import { SlEnergy } from "react-icons/sl";
import { MdOutlineHealthAndSafety } from "react-icons/md";
import { TbGolf } from "react-icons/tb";
import { PiSwimmingPool } from "react-icons/pi";
import {Helmet} from "react-helmet";
import { BsBuildingCheck } from "react-icons/bs";

import { GrShieldSecurity } from "react-icons/gr";

import { MdOutlineWaterDrop } from "react-icons/md";

import { MdOutlineBathroom } from "react-icons/md";
import { MdOutlineWarehouse } from "react-icons/md";
import { MdOutlineGasMeter } from "react-icons/md";
import { TbParkingCircle } from "react-icons/tb";
import { TbTrash } from "react-icons/tb";
import { MdOutlineCleaningServices } from "react-icons/md";
import { TbAirConditioning } from "react-icons/tb";

import propertImg1 from "../../../assets/images/property/img8.jpg";
import propertImg2 from "../../../assets/images/property/img10.jpg";
import propertImg3 from "../../../assets/images/property/img7.jpg";
import propertImg4 from "../../../assets/images/property/img2.jpg";
import propertImg5 from "../../../assets/images/property/img3.jpg";
import propertImg6 from "../../../assets/images/property/video_thump.webp";
import propertImg7 from "../../../assets/images/property/360.webp";
import propertyAudio1 from '../../../assets/audio/audio1.mp3'
import relatedPropertyImg1 from '../../../assets/images/property/img1.jpg'
import relatedPropertyImg2 from '../../../assets/images/property/img2.jpg'
import relatedPropertyImg3 from '../../../assets/images/property/img3.jpg'
import relatedPropertyImg4 from '../../../assets/images/property/img4.jpg'
import relatedPropertyImg5 from '../../../assets/images/property/img5.jpg'
import relatedPropertyImg6 from '../../../assets/images/property/img6.jpg'
import relatedPropertyImg7 from '../../../assets/images/property/img7.jpg'
import relatedPropertyImg8 from '../../../assets/images/property/img8.jpg'
import mapImg from '../../../assets/images/property/map.webp'
import { LazyLoadImage } from "react-lazy-load-image-component";

const path = "/keralaplots/";


function InnerProperty() {
    const [data ,setData] = useState([]);
    const [isPopupVisible, setIsPopupVisible] = useContext(LoginPopupContext);
    const { id } = useParams();
    const galleryRef = useRef(null);
    const videoRefs = useRef([]); // Array of refs for multiple videos
    const [playingVideoIndex, setPlayingVideoIndex] = useState(null);
    const [isSaved, setIsSaved] = useState(false); // State to track if the property is saved
    const [activeTab, setActiveTab] = useState(1); // Track the active tab
    const [isScrolled, setIsScrolled] = useState(false); // State to track scrolling
    const [isSellerPopupVisible, setIsSellerPopupVisible] = useState(false);
    const BASE_URL = "https://keralaplots.com/keralaplots/postProperty/assets/images/PropertyImage/";
    const AUDIO_URL = "https://keralaplots.com/keralaplots/postProperty/assets/images/PropertyAudio/";
    const BASE_URL_NOIMG = "nophoto.webp";
    const [images, setImages] = useState([]);
    const property_id = id
    const jwtToken = localStorage.getItem('jwtToken');
    const loginId = localStorage.getItem('login_id');
    const [propertyAudio, setPropertyAudio] = useState(null);


    useEffect(() => {
        setData({});
        setImages([]);
        axios.get(`${baseURL}/fetch_property_inner/`, {
            params: { id, loginId },
        })
        .then((res) => {
            setData(res.data[0]);
            setIsSaved(res.data[0].savedStatus);
        })
        .catch((err) => console.log(err));
    }, [id, loginId]);

    useEffect(() => {
        const STORAGE_KEY = "viewedPropertyIds";
        const TIMESTAMP_KEY = "viewedPropertyTimestamp";
    
        const updateViewCount = () => {
            // Get the current date without time (midnight)
            const currentDate = new Date().setHours(0, 0, 0, 0);
    
            // Get saved data and timestamp from local storage
            let savedIds = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
            const savedTimestamp = localStorage.getItem(TIMESTAMP_KEY);
    
            console.log("Initial savedIds:", savedIds);
    
            // Reset the array if a day has passed
            if (!savedTimestamp || new Date(Number(savedTimestamp)).setHours(0, 0, 0, 0) !== currentDate) {
                localStorage.setItem(STORAGE_KEY, JSON.stringify([]));
                localStorage.setItem(TIMESTAMP_KEY, currentDate);
                savedIds = []; // Reset savedIds to reflect the change
            }
    
            console.log("Current savedIds before check: ", savedIds);
    
            // **Force re-read from localStorage here**
            savedIds = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
            console.log("Current savedIds after re-read: ", savedIds);
    
            // Check if the property ID is already saved for today
            if (!savedIds.includes(id)) {
                // Add the property ID to the array and save it to local storage
                const updatedIds = [...savedIds, id];
                localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedIds));
    
                // **Force re-read again to ensure the update is immediate**
                savedIds = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
                console.log("Final savedIds after update: ", savedIds);
    
                // Call the API to update view count
                axios.post(`${baseURL}/updatePropertyViewCount`, {
                    propertyId: id,
                    loginId
                })
                .then(() => {
                    console.log("View count updated successfully");
                })
                .catch(err => console.error("Error updating property view count:", err));
            }
        };
    
        updateViewCount();
    }, [id, loginId]);
    
    
    
    
    useEffect(() => {
        if (!data.propertyType || !data.district || !data.town || !data.street) return;
        const fetchRelatedProperties = async () => {
            try {
                const res = await axios.get(`${baseURL}/getRelatedProperties`, {
                    params: {
                        propertyType: data.propertyType,
                        district: data.district,
                        town: data.town,
                        street: data.street,
                        loginId,
                        id,
                    },
                });
                setData((prevData) => ({
                    ...prevData,
                    relatedProperties: res.data || [],
                }));
            } catch (error) {
                console.error("Error fetching related properties:", error.message);
            }
        };
        fetchRelatedProperties();
    }, [data.propertyType, data.district, data.town, data.street]);
    
    const propertyEndpoints = {
        'Residential Land': 'getPoperty_area_details_RL',
        'Residential Apartment': 'getPoperty_area_details_RA',
        'Residential House/Villa': 'getPoperty_area_details_RV',
        'Commercial Land': 'getPoperty_area_details_CL',
        'Commercial Building': 'getPoperty_area_details_CB',
        'Commercial Shop': 'getPoperty_area_details_CS',
        'Commercial Office': 'getPoperty_area_details_COF',
        'Commercial Other': 'getPoperty_area_details_COT',
        'Industrial Building': 'getPoperty_area_details_INB',
        'Industrial Land': 'getPoperty_area_details_INL',
        'Agricultural Land': 'getPoperty_area_details_AL',
    };

    const getAmenitiesEndpoint = () => {
        if (data.propertyType.includes('Commercial')) return 'Commerical'; // Ensure correct spelling on the backend
        if (data.propertyType.includes('Industrial')) return 'Industrial';
        return 'Residential';
    };

    const getNearbyEndpoint = () => {
        if (data.propertyType.includes('Commercial')) return 'Commerical'; // Ensure correct spelling on the backend
        if (data.propertyType.includes('Industrial')) return 'Industrial';
        return 'Residential';
    };
    
    useEffect(() => {
        if (!data.propertyType || !propertyEndpoints[data.propertyType]) return;

        //console.log("Property Type:", data.propertyType);
        //console.log("API Endpoint:", `${baseURL}/${propertyEndpoints[data.propertyType]}/${property_id}`);

        //console.log(`${propertyEndpoints[data.propertyType]}`)
        //console.log(`${baseURL}/${propertyEndpoints[data.propertyType]}/${property_id}`)
        const fetchPropertyDetails = axios.get(`${baseURL}/${propertyEndpoints[data.propertyType]}/${property_id}`);
        const fetchAmenities = axios.get(`${baseURL}/get${getAmenitiesEndpoint()}Amenities/${property_id}`);
        const fetchNearby = axios.get(`${baseURL}/get${getNearbyEndpoint()}Nearby/${property_id}`);
        const fetchPropertyImg = axios.get(`${baseURL}/fetch_property_img/${property_id}`);
        const fetchPropertyVideo = axios.get(`${baseURL}/fetch_property_Video/${property_id}`);
        const fetchPropertyAudio = axios.get(`${baseURL}/fetch_property_Audio/${property_id}`);
        Promise.all([fetchPropertyDetails, fetchAmenities, fetchNearby, fetchPropertyImg, fetchPropertyVideo, fetchPropertyAudio])
            .then(([propertyDetailsRes, amenitiesRes, nearbyRes, propertyImgRes, propertyVideoRes, propertyAudioRes]) => {
                //console.log("fetchPropertyDetails ",fetchPropertyDetails)
                //console.log("fetchPropertyDetails ",propertyDetailsRes)
                if (propertyAudioRes.data.data && propertyAudioRes.data.data.length > 0) {
                    setPropertyAudio(propertyAudioRes.data.data[0].audio_name);
                }
                setData((prevData) => {
                    
                    const propertyDetails = propertyDetailsRes.data?.data?.[0] || propertyDetailsRes.data?.[0] || {}; 
                    console.log("📌 Final Property Data:", propertyDetails);
                
                    return {
                        ...prevData,
                        ...propertyDetails,
                        amenities: amenitiesRes.data || {},
                        nearby: nearbyRes.data || [],
                    };
                });
            
                
                
                
                const imagesArray = Array.isArray(propertyImgRes.data.data) ? propertyImgRes.data.data : [];
                //console.log("propertyImgRes :",propertyImgRes.data.data)
                /**setImages((prevImages) => [
                    ...prevImages,
                    ...imagesArray.map((img) => ({
                        original: `${BASE_URL}${img.imageName}`,
                        thumbnail: `${BASE_URL}${img.imageName}`,
                    })),
                ]);*/

                setImages(() => {
                    let formattedImages = [];
                
                    if (imagesArray.length > 0) {
                        formattedImages = imagesArray.map((img) => ({
                            original: `${BASE_URL}${img.imageName}`,
                            thumbnail: `${BASE_URL}${img.imageName}`,
                        }));
                    } else {
                        formattedImages = [{
                            original: `${BASE_URL}${BASE_URL_NOIMG}`,
                            thumbnail: `${BASE_URL}${BASE_URL_NOIMG}`,
                        }];
                    }
                
                    // Add property video if it exists
                    if (propertyVideoRes.data.data && propertyVideoRes.data.data.length > 0) {
                        formattedImages.push({
                            original: `https://keralaplots.com/keralaplots/postProperty/assets/images/PropertyVideo/${propertyVideoRes.data.data[0].video_name}`,
                            thumbnail: propertImg6,
                            isVideo: true,
                        });
                    }
                
                    // Conditionally add Google Street View iframe
                    // if (data.googlestreetview) {
                    //     formattedImages.push({
                    //         original: data.googlestreetview.match(/src="([^"]+)"/)?.[1] || data.googlestreetview,
                    //         thumbnail: propertImg7,
                    //         isIframe: true,
                    //     });
                    // }   
                    if (data.googlestreetview) {
                        const streetViewUrl = data.googlestreetview.match(/src="([^"]+)"/)?.[1] || data.googlestreetview;
                        
                        formattedImages.push({
                            original: streetViewUrl,
                            thumbnail: propertImg7,
                            isIframe: streetViewUrl.includes("google.com/maps/embed"), // Check if it's an iframe
                            isMap: !streetViewUrl.includes("google.com/maps/embed"), // True if it's NOT an iframe
                        });
                    }
                    
                
                    return formattedImages;
                });
                
                setIsLoading(false);
            })
            .catch((err) => {
                console.error('Error fetching property data:', err.message);
                setIsLoading(false); // ✅ Also stop loading in case of an error
            });
            
    }, [data.propertyType, property_id]);

     // Add dependencies to rerun the effect when these values change
    const amenities = data?.amenities; 
    console.log("amenities :",amenities)
    const relatedProperties = data?.relatedProperties;
    const nearby = data?.nearby; 
    const propertyImg = data?.propertyImg; 
    //const amenitiesData = data?.amenities?.data || [];
    let displayedImage;
    console.log("Updated data:", data);
    if (!propertyImg || Object.keys(propertyImg).length === 0) {
        displayedImage = propertImg1;
    }else{
        displayedImage = propertyImg[0];
    }
    let nearBy_status
    if (Array.isArray(nearby?.data) && nearby.data.length > 0) {
    if (
        nearby?.data &&
        nearby.data[0] &&
        nearby.data[0].school === 0 &&
        nearby.data[0].hospital === 0 &&
        nearby.data[0].busstop === 0 &&
        nearby.data[0].airport === 0 &&
        nearby.data[0].railway === 0 &&
        nearby.data[0].supermarket === 0 &&
        nearby.data[0].atm === 0 &&
        nearby.data[0].petrolpumb === 0 &&
        nearby.data[0].restaurant === 0 &&
        nearby.data[0].shopping === 0
    ) {
        nearBy_status = 0;
    }else{
       // console.log("school "+nearby.data[0].school)
        nearBy_status = 1;
    }
}else{
    nearBy_status = 0;
}

    // Scroll Event Handler
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 200) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    // tab
    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        // Scroll to the corresponding section
        const element = document.getElementById(`tabBox${tabIndex}`);
        if (element) {
            // element.scrollIntoView({ behavior: "smooth" });
            window.scrollTo({
                top: element.offsetTop - 170,  // Subtract 100px to account for the offset
                behavior: 'smooth',
            });
        }
    };

   
    const handleSaveClick = async() => {
        const propertyId=id;
        const token = localStorage.getItem('jwtToken'); // Get JWT token
        const login_id = localStorage.getItem('login_id');
        //const previousAction = localStorage.getItem("previousAction");
        //console.log(previousAction)
        if (!token) {
            // Store the previous action in localStorage
            localStorage.setItem("previousAction", JSON.stringify({
                action: "handleSaveClick",
                data: { propertyId, savedstatus: !isSaved }
            }));
            setIsPopupVisible(true)
            return;
        }
        else{
            const newSavedState = !isSaved;
            setIsSaved(newSavedState);
            
            try {
                const response = await axios.post(
                    `${baseURL}/addpropertywishlist`, 
                    { propertyId,login_id,savedstatus: newSavedState},
                    {
                        headers: { Authorization: `Bearer ${token}` }
                    }
                );
                console.log(response.status)
                if (response.status==200) {
                    //setIsSaved(true);
                    if (!isSaved) {
                        toast.success("Property saved successfully!"); // Show success message when saved
                    } else {
                        toast.info("Property removed from saved list."); // Show info message when unsaved
                    }
                } else {
                    toast.error(response.data.message || "Failed to save property.");
                }
            } catch (error) {
                toast.error("An error occurred while saving the property.");
            }
        }
    };

    const togglePlayPause = (index) => {
        const videoRef = videoRefs.current[index];
        if (videoRef) {
            if (playingVideoIndex === index) {
            videoRef.pause();
            setPlayingVideoIndex(null);
            } else {
            videoRefs.current.forEach((video, i) => {
                if (i !== index && video) video.pause();
            });
            videoRef.play();
            setPlayingVideoIndex(index);
            }
        }
    };

    const handleVideoEnd = (index) => {
        if (playingVideoIndex === index) {
            setPlayingVideoIndex(null);
        }
    };

    // Open map in new tab
    const handleMapClick = (url) => {
        if (url) {
            window.open(url, "_blank");
        }
    };

    const renderItem = (item, index) => {
        console.log("Rendering item:", item); // Debugging

        if (item.isVideo) {
            return (
                <div className="imageGalleryVideo">
                    <video
                        ref={(el) => (videoRefs.current[index] = el)} // Assign ref to each video
                        muted
                        onEnded={() => handleVideoEnd(index)}
                        style={{ width: "100%", borderRadius: "10px" }}
                    >
                        <source src={item.original} type="video/mp4" />
                        Your browser does not support HTML video.
                    </video>
                    <button
                        onClick={() => togglePlayPause(index)}
                        className="imageGalleryVideoPlayBtn"
                        style={{
                            display: playingVideoIndex === index ? "none" : "flex",
                        }}
                    >
                        {playingVideoIndex === index ? <PiPauseCircleBold /> : <PiPlayCircleBold />}
                    </button>
                </div>
            );
        }

        if (item.isIframe) {
            return (
                <iframe
                    width="100%"
                    height="315"
                    src={item.original}
                    title="Iframe Content"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                ></iframe>
            );
        }

        return (
            <div className="galleryBoxInner">
                <img src={item.original} alt="Property" />
                {item.isMap && (
                    <div className="viewMapBtnBox">
                        <img src={mapImg} alt="Map Icon" />
                        <div className="viewMapBtnBoxMain" onClick={() => handleMapClick(item.original)}>
                            <div className="viewMapBtn">View 360<sup>o</sup> Map</div>
                        </div>
                    </div>
                )}
            </div>
        );
    };

    // realated property slider
    const carouselRef = useRef(null); // Reference for carousel
    const settings = {
    dots: false,
    loop: true,
    nav: false, // Disable default navigation
    margin: 20,
    autoplay: true,
    autoplayTimeout: 2000,
    autoplayHoverPause: true,
    responsive: {
        0: { items: 1 },
        600: { items: 2 },
        1000: { items: 3 },
        1200: { items: 4 },
    },
    };

    // Custom Next & Prev Handlers
    const goToNext = () => {
    if (carouselRef.current) {
        carouselRef.current.next();
    }
    };

    const goToPrev = () => {
    if (carouselRef.current) {
        carouselRef.current.prev();
    }
    };

    // skelly loader
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        fetchUserDetails_get();
    }, []);

    // seller details popup
    const showSellerPopup = () => {

        const token = localStorage.getItem('jwtToken'); // Get JWT token
        const login_id = localStorage.getItem('login_id');

        if (!token) {
            setIsPopupVisible(true)
            return;
        }
        else{
            setIsSellerPopupVisible(true);
            document.body.style.overflow = "hidden";
        }
        
    };

    const hideSellerPopup = () => {
        setIsSellerPopupVisible(false);
        document.body.style.overflow = "inherit";
    };

    // copy id
    const innerHandleCopyId = (e) => {
        // Retrieve the ID dynamically from the component's content
        const idToCopy = e.currentTarget.querySelector("h3").textContent;
    
        navigator.clipboard.writeText(idToCopy)
        .then(() => {
            toast.success(`Property ID ${idToCopy} copied to clipboard!`); // Show toast notification
        })
        .catch(() => {
            toast.error("Failed to copy Property ID."); // Show error if copy fails
        });
    };

    const [nameVal, setName] = useState();
    const [Phonenum, setPhonenum] = useState();
    const [Characterfirst, setCharacterfirst] = useState();
    const [roleval, setSelectedRole] = useState();
    const [PhoneNumbers, setPhoneNumbers] = useState([]);
    const [LoginIdval, setLoginId] = useState();
    const fetchUserDetails_get = async () => {  
        try {
            const response = await axios.post(`${baseURL}/fetchuserdetailsidproperties`, {
                property_id: id,
            });
            const userdetails=response.data.userdetails[0];
            console.log(userdetails)
            const alternativenum=response.data.alternativenum;
                setLoginId(userdetails.loginId)
                setName(userdetails.userName)
                setPhonenum(userdetails.phone_number)
                setCharacterfirst(userdetails.userName.charAt(0))
                setSelectedRole(userdetails.role_val)
    
                if (Array.isArray(alternativenum)) {
                    setPhoneNumbers(alternativenum.map(item => item.phone_number.toString()));
                }
    
        } catch (error) {
            console.error(error);
        }
    };  

    const handleClick = async() => {  
       const login_id_val=localStorage.getItem('login_id')
    const response=await axios.post(`${baseURL}/Clickpropertycontactusers`,{
        propertyId:id,
        login_id:login_id_val
    })
    console.log(response.data)
    };


    // handleCopy
    const handleCopy = () => {
        const content = `Property: ${data.propertyType}\n${window.location.href}`;
        navigator.clipboard.writeText(content);
        toast.success(`Copied: ${content}`);
    }

    // handleShareWhatsapp
    const handleShareWhatsapp = () => {
        const content = `Property: ${data.propertyType}\n${window.location.href}`;
        const url = `whatsapp://send?text=${encodeURIComponent(content)}`;
        window && window.open(url, '_blank');
    }


    // audio player
    const [audio, setAudio] = useState(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [currentTime, setCurrentTime] = useState(0);
    const [duration, setDuration] = useState(0);
    const [volume, setVolume] = useState(0.75);
    const [isMuted, setIsMuted] = useState(false);
    const progressRef = useRef(null);
    const volumeRef = useRef(null);
    const [audioVoliumBar, setaudioVoliumBar] = useState(true);
    
    
    useEffect(() => {
        if (propertyAudio) {
            if (audio) {
                audio.pause(); // Stop previous audio
            }
    
            const newAudio = new Audio(propertyAudio);
            newAudio.volume = volume;
            newAudio.crossOrigin = "anonymous"; // Fix CORS issue if needed
            newAudio.load(); // Ensure metadata is loaded
    
            const updateDuration = () => {
                if (!isNaN(newAudio.duration) && newAudio.duration > 0 && newAudio.duration !== Infinity) {
                    console.log("Metadata loaded, duration:", newAudio.duration);
                    setDuration(newAudio.duration);
                } else {
                    console.log("Retrying duration update...");
                    setTimeout(updateDuration, 500); // Retry after 500ms if duration is not valid
                }
            };
    
            // Add event listeners
            newAudio.addEventListener("loadedmetadata", updateDuration);
            newAudio.addEventListener("canplaythrough", updateDuration);
            newAudio.addEventListener("timeupdate", () => setCurrentTime(newAudio.currentTime));
    
            // Set new audio object
            setAudio(newAudio);
    
            return () => {
                // Remove event listeners
                newAudio.removeEventListener("loadedmetadata", updateDuration);
                newAudio.removeEventListener("canplaythrough", updateDuration);
                newAudio.removeEventListener("timeupdate", () => setCurrentTime(newAudio.currentTime));
                newAudio.pause();
            };
        }
    }, [propertyAudio]);
    
    

    const togglePlay = () => {
        if (isPlaying) {
            audio.pause();
        } else {
            audio.play().catch(error => console.error("Audio play failed:", error));
        }
        setIsPlaying(!isPlaying);
    };

    const changeTime = (e) => {
        if (!audio || isNaN(duration) || duration <= 0) {
            console.warn("Invalid duration:", duration);
            return; // Prevent setting invalid time
        }
    
        if (!progressRef.current || progressRef.current.offsetWidth === 0) {
            console.warn("Invalid progress bar width");
            return; // Prevent division by zero
        }
    
        const newTime = (e.nativeEvent.offsetX / progressRef.current.offsetWidth) * duration;
    
        if (isFinite(newTime) && newTime >= 0 && newTime <= duration) {
            audio.currentTime = newTime;
            setCurrentTime(newTime);
        } else {
            console.warn("Calculated newTime is invalid:", newTime);
        }
    };
    
    const changeVolume = (e) => {
        const newVolume = e.nativeEvent.offsetX / volumeRef.current.offsetWidth;
        setVolume(newVolume);
        audio.volume = newVolume;
    };
    
    const toggleMute = () => {
        setIsMuted(!isMuted);
        audio.muted = !isMuted;
        setaudioVoliumBar(!audioVoliumBar);
    };
    
    const formatTime = (num) => {
        if (!num || isNaN(num) || num <= 0 || !isFinite(num)) return "0:00"; // Ensure a default value
    
        let seconds = Math.floor(num % 60);
        let minutes = Math.floor((num / 60) % 60);
        return `${minutes}:${String(seconds).padStart(2, "0")}`;
    };  
    
    return (
        <>
            <Tooltip id="my-tooltip" />
            
            <Helmet>
                <meta property="og:image" content={propertImg1} />
            </Helmet>

            {/* propertyOverviewStrip */}
            <div className={`propertyOverviewStrip ${isScrolled ? 'propertyOverviewStripActive' : ''}`}>
                <div className="container">
                    <div className="propertyOverviewStripMain">
                        <div className="innerPropertyHeadDetails">
                            <div className="innerPropertyHeadDetailsCol1">
                                <div className="innerPropertyHeadDetailsThumbnail">
                                    <img src={propertImg1} alt="" />
                                </div>
                                <div className="innerPropertyHeadDetailsBox">
                                {isLoading || !data || Object.keys(data).length === 0 ? (
    <div className="skeleton-loader">
        <div className="skeleton-icon"></div>
        <div className="skeleton-text"></div>
    </div>
) : (
    <>
        <div className="propertyPrice">
            <div className="propertyPriceIcon">
                <BiRupee />
            </div>
            {data.priceVisibility === "No" ? "Not disclosed" : data.propertyPricerange}
        </div>
        <div className="propertyName">
            {data.propertyType} For {data.propertyAction === "sell" ? "Sale" : data.propertyAction}
        </div>
        <div className="propertyLocation">
            {data?.town && data?.district ? `${data.town}, ${data.district}` : "Location not available"}
        </div>
    </>
)}

</div>

                            </div>
                            <div className="innerPropertyHeadDetailsCol3">
                                {console.log("login ",data.loginId)}
                            {data.loginId == loginId ? (
                                <div className="myPropertyIcon tootlTip">
                                    <BsBuildingCheck />
                                    <div className="tootlTipPopup">My Property</div>
                                </div>
                                ) : (
                                <div className={`propertySaveBtn ${isSaved ? 'saved' : ''}`} onClick={handleSaveClick}>
                                <div className="propertySaveBtnIcon">
                                    {isSaved ? <BiSolidHeart style={{ color: 'red' }} /> : <BiHeart />}
                                </div>
                                </div>
                                )}
                                <div className="propertyContactBtn" onClick={showSellerPopup}>Contact Now</div>
                            </div>
                        </div>
                        <div className="innerPropertyHeadTab">
                            <ul>
                                <li>
                                    <div
                                        className={`innerPropertyHeadTabBtn ${activeTab === 1 ? 'innerPropertyHeadTabBtnActive' : ''}`}
                                        onClick={() => handleTabClick(1)}
                                    >
                                        Overview
                                    </div>
                                </li>
                                <li>
                                    <div
                                        className={`innerPropertyHeadTabBtn ${activeTab === 2 ? 'innerPropertyHeadTabBtnActive' : ''}`}
                                        onClick={() => handleTabClick(2)}
                                    >
                                        Basic Details
                                    </div>
                                </li>
                                {amenities && Array.isArray(amenities.data) && amenities.data.length > 0 && (
                                    
                                    <>
                                    {console.log("amenities div inner")}
                                <li>
                                    <div
                                        className={`innerPropertyHeadTabBtn ${activeTab === 3 ? 'innerPropertyHeadTabBtnActive' : ''}`}
                                        onClick={() => handleTabClick(3)}
                                    >
                                        Amenities
                                    </div>
                                </li>
                                </>
                                )}
                                {nearby && Object.keys(nearby).length > 0 && nearBy_status === 1 && (
                                <li>
                                    <div
                                        className={`innerPropertyHeadTabBtn ${activeTab === 4 ? 'innerPropertyHeadTabBtnActive' : ''}`}
                                        onClick={() => handleTabClick(4)}
                                    >
                                        Nearby
                                    </div>
                                </li>
                                )}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            {/* propertyOverviewStrip close */}

            {/* Contact Details popup */}
            {isSellerPopupVisible && (
            <div className="contactDetailsPopup">
                <div className="contactDetailsPopupBox">
                    <div className="closeContactDetailsPopup" onClick={hideSellerPopup}>
                        <RiCloseLargeFill />
                    </div>
                    <div className="contactDetailsPopupBoxStrip">
                        <div className="contactDetailsPopupBoxStripIcon"><BsStars /></div>
                        <p>Good Choice! Top-rated project in this region</p>
                    </div>
                    <div className="contactDetailsPopupBoxHead">
                        <h3>Contact Seller</h3>
                        <a href="" className="contactDetailsPopupBoxHeadProfile">
                            <div className="contactDetailsPopupBoxHeadProfileThumbnail">
                                <h4>{Characterfirst}</h4>
                            </div>
                            <div className="contactDetailsPopupBoxHeadProfileDetails">
                                <div className="sellerName">{nameVal}</div>
                                <div className="sellerType">{roleval}</div>
                            </div>
                            {/* <div className="contactDetailsPopupBoxHeadProfileViewBtn">
                                <FaChevronRight />
                            </div> */}
                        </a>
                    </div>
                    <div className="contactDetailsPopupBoxBody">
                        <ul className="contactDetailsPopupBoxPropertyDetails">
                            <li>
                                <p>Property ID :</p>
                                <h4>{id}</h4>
                            </li>
                            <li>
                                <p>User Type :</p>
                                <h4>{roleval}</h4>
                            </li>
                        </ul>
                        <div className="contactDetailsPopupBoxPhoneNumber">
                            <h3>Phone Number</h3>
                            <ul>
                                <li>
                                    <a href={`tel:+91${Phonenum}`} onClick={() => handleClick()}>
                                        <p>+91 {Phonenum}</p>
                                        <span>Call</span>
                                    </a>
                                </li>
                                
                            
                                {PhoneNumbers.map((phoneNumber, index) => (
                                    <li key={index}>
                                    <a href={`tel:+91${phoneNumber}`} onClick={() => handleClick()}>
                                        <p>{`+91 `+(phoneNumber)}</p>
                                        <span>Call</span>
                                    </a>
                                    </li>
                                ))}

                            {data.email &&(
                                <li>
                                    <a href={`mailto:${data.email}`} onClick={() => handleClick()}>
                                        <p>{data.email}</p>
                                        <span>Mail Us</span>
                                    </a>
                                </li>
                                )}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            )}
            {/* Contact Details popup close */}

            <section id="innerProperty">
                <div className="container" id="tabBox1">
                    <div className="innerPropertyBreadCrubms">
                        <a href="/keralaplots">Home</a>
                        <span>/</span>
                        <a href="/keralaplots/properties">Properties</a>
                        <span>/</span>
                        <p>{data.propertyType}</p>
                    </div>
                </div>
                <div className="innerPropertyHead">
                    <div className="container">
                        <div className="innerPropertyHeadDetails">
                            <div className="innerPropertyHeadDetailsCol1">
                                <div className="propertyPrice">
                                    <div className="propertyPriceIcon">
                                        <BiRupee />
                                    </div>
                                    {data.priceVisibility === "No" ? "Not disclosed" : data.propertyPricerange}
                                </div>
                                <div className="propertyName">
    {data?.propertyType && data?.propertyAction 
        ? `${data.propertyType} For ${data.propertyAction === 'sell' ? 'Sale' : data.propertyAction}` 
        : "Data not available"}
</div>

                                <div className="propertyLocation">{data?.town && data?.district ? `${data.town}, ${data.district}` : "Location not available"}</div>
                            </div>
                            <div className="innerPropertyHeadDetailsCol3">
                            {data.loginId == loginId ? (
                                <div className="myPropertyIcon tootlTip">
                                    <BsBuildingCheck />
                                    <div className="tootlTipPopup">My Property</div>
                                </div>
                            ):(
                                <div
                                    className={`propertySaveBtn ${isSaved ? 'saved' : ''}`}
                                    onClick={handleSaveClick}
                                    >
                                    <div className="propertySaveBtnIcon">
                                        {isSaved ? <BiSolidHeart style={{ color: 'red' }} /> : <BiHeart />}
                                    </div>
                                    
                                </div>
                            )}
                                <div className="propertyContactBtn" onClick={showSellerPopup}>Contact Now</div>
                            </div>
                        </div>
                        <div className="innerPropertyHeadTab">
                            <ul>
                                <li>
                                    <div
                                        className={`innerPropertyHeadTabBtn ${activeTab === 1 ? 'innerPropertyHeadTabBtnActive' : ''}`}
                                        onClick={() => handleTabClick(1)}
                                    >
                                        Overview
                                    </div>
                                </li>
                                <li>
                                    <div
                                        className={`innerPropertyHeadTabBtn ${activeTab === 2 ? 'innerPropertyHeadTabBtnActive' : ''}`}
                                        onClick={() => handleTabClick(2)}
                                    >
                                        Basic Details
                                    </div>
                                </li>
                                {amenities && Array.isArray(amenities.data) && amenities.data.length > 0 && (
                                    <>
                                <li>
                                    <div
                                        className={`innerPropertyHeadTabBtn ${activeTab === 3 ? 'innerPropertyHeadTabBtnActive' : ''}`}
                                        onClick={() => handleTabClick(3)}
                                    >
                                        Amenities
                                    </div>
                                </li>
                                </>
                                )}
                                {nearby && Object.keys(nearby).length > 0 && nearBy_status === 1 && (
                                <li>
                                    <div
                                        className={`innerPropertyHeadTabBtn ${activeTab === 4 ? 'innerPropertyHeadTabBtnActive' : ''}`}
                                        onClick={() => handleTabClick(4)}
                                    >
                                        Nearby
                                    </div>
                                </li>
                                )}
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="innerPropertyMain">
                        <div className="innerPropertyOverview">
                            <div className="innerPropertyThumbnail">
                            {isLoading ? (
                                <div className='SkeletonLoader'>
                                    <div className='SkeletonLoaderBox'>
                                        <div className="SkeletonLoaderBoxCol1">
                                            <Skeleton />
                                        </div>
                                        <Skeleton />
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <div className="innerPropertyThumbnailBox">
                                        <div className="propertyPurposeTag">{data.propertyAction === 'sell' ? 'Sale' : data.propertyAction}</div>
                                        {/* <Gallery items={images} ref={galleryRef} renderItem={renderItem} /> */}
                                        {/* <Gallery items={images} ref={galleryRef} renderItem={(item) => (
                                            <div className="galleryBox">
                                                {item.isIframe ? (
                                                    <iframe src={item.original} style={{ border: "none" }} />
                                                ) : (
                                                    <div className="galleryBoxInner">
                                                        <img src={item.original} alt="Property" />
                                                        <video controls>
                                                            <source src={item.original} type="video/mp4" />
                                                        </video>
                                                        {item.isMap && (
                                                            <div className="viewMapBtnBox">
                                                                    <img src={mapImg} alt="" />
                                                                <div className="viewMapBtnBoxMain" 
                                                                        onClick={() => window.open(item.original, "_blank")}>
                                                                    <div 
                                                                        className="viewMapBtn"
                                                                    >
                                                                        View 360<sup>o</sup> Map
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        )} /> */}
                                        <Gallery items={images} ref={galleryRef} renderItem={renderItem} />
                                        <div 
                                            className="propertyIdBox" 
                                             
                                            onClick={innerHandleCopyId}
                                        >
                                            {/* data-tooltip-id="my-tooltip" 
                                            data-tooltip-content="Copy ID" */}
                                            <p>ID :</p>
                                            <h3>{id}</h3>
                                            <div className="copyIdBtn"><MdFileCopy /></div>
                                        </div>
                                    </div>
                                </>
                            )}
                            </div>
                            <div className="innerPropertyDetails">
                                <div className="propertyDateShare">
                                    <div className="propertyShareBtn">
                                        <div className="propertyShareBtnIcon">
                                            <PiShareFat />
                                        </div>
                                        Share
                                        <div className="propertySharePopup">
                                            <ul>
                                                <li className='copyLink' onClick={handleCopy}>
                                                    <div className="icon">
                                                        <FiCopy />
                                                    </div>
                                                    <p>Copy Link</p>
                                                </li>
                                                <li className='shareWhatsapp' onClick={handleShareWhatsapp}>
                                                    <div className="icon">
                                                        <MdWhatsapp />
                                                    </div>
                                                    <p>Share Whatsapp</p>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <p>Posted On : {data.addedDate?.split(" ")[0]}</p>
                                </div>
                               
                                {propertyAudio && (
                                <div className="propertyAudioPlayer">
                                    {/* <ReactAudioPlayer
                                        src={`${AUDIO_URL}${propertyAudio}`}
                                        controls
                                        showSkipControls={false}
                                        showDownloadControl={false}
                                        showVolumeControl={true}
                                        controlsList="nodownload"
                                    /> */}
                                    <audio controls>
                                        <source src={`${AUDIO_URL}${propertyAudio}`} type="audio/ogg" />
                                        <source src={`${AUDIO_URL}${propertyAudio}`} type="audio/mpeg" />
                                        Your browser does not support the audio element.
                                    </audio>
                                    {/* <div className="audio-player">
                                        <div className="timeline" ref={progressRef} onClick={changeTime}>
                                            <div className="progress" style={{ width: `${(currentTime / duration) * 100}%` }}></div>
                                        </div>
                                        <div className="controls">
                                            <div className="play-container">
                                                <div className={`toggle-play ${isPlaying ? "pause" : "play"}`} onClick={togglePlay}></div>
                                            </div>
                                            <div className="time">
                                                <div className="current">{formatTime(currentTime)}</div>
                                                <div className="divider">/</div>
                                                <div className="length">{formatTime(duration)}</div>
                                            </div>
                                            <div className="volume-container">
                                                <div className="volume-button" onClick={toggleMute}>
                                                    <div className={`volume ${isMuted ? "icono-volumeMute" : "icono-volumeMedium"}`}>
                                                        {isMuted ? <IoVolumeMute /> : <IoVolumeMedium />}
                                                    </div>
                                                </div>
                                                {audioVoliumBar && (
                                                <div className="volume-slider" ref={volumeRef} onClick={changeVolume}>
                                                    <div className="volume-percentage" style={{ width: `${volume * 100}%` }}></div>
                                                </div>
                                                )}
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                                )}

                                <p className="propertyDescription">{data?.propertyDes ? `${data.propertyDes}` : 'Loading...'}</p>
                                <p className="propertyDescription">
                                {data?.propertyType 
                                    ? `${data.propertyType} in ${data?.district || "N/A"}, ${data?.town || "N/A"}, ${data?.locality || "N/A"}, ${data?.PropertyAdreess || "N/A"} for ${data?.propertyAction || "N/A"}`
                                    : "Property details not available"}
                                </p>

                                <div className="propertyDetailsListBox">
    <h3>Property Overview</h3>
    <ul className="propertyOverview">
        {data.propertyType !== "Residential Land" &&  data.propertyType !== "Commercial Land" &&  data.propertyType !== "Commercial Building" &&  data.propertyType !== "Commercial Shop" && data.propertyType !== "Commercial Office" && data.propertyType !== "Commercial Other" && data.propertyType !== "Industrial Building"&& data.propertyType !== "Industrial Land"&&  data.propertyType !== "Agricultural Land"&&(
            <>
                <li>
                    <div className="icon">
                        <IoBedOutline />
                    </div>
                    <div className="details">
                        <p>Bed Rooms</p>
                        <h4>{data.Bedrooms || "No Data"}</h4>
                    </div>
                </li>
                <li>
                    <div className="icon">
                        <PiBathtub />
                    </div>
                    <div className="details">
                        <p>Bath Rooms</p>
                        <h4>{data.Bathrooms || "No Data"}</h4>
                    </div>
                </li>
            </>
        )}
        <li>
            <div className="icon">
                <IoMapOutline />
            </div>
            <div className="details">
    <p>Area</p>
    <h4>
        {data?.propertyType
            ? ["Residential Land", "Commercial Land", "Industrial Land", "Agricultural Land"].includes(data.propertyType)
                ? (data.Landarea ? data.Landarea + " " + data.landareaunit : "No Data")
                : ["Residential Apartment", "Commercial Building", "Residential House/Villa", "Commercial Shop", "Commercial Office", "Commercial Other", "Industrial Building"].includes(data.propertyType)
                    ? (data.Builtarea ? data.Builtarea + " " + data.builtareaunit : "No Data")
                    : "No Data"
            : "Loading..."}
    </h4>
</div>

        </li>
        <li>
            <div className="icon">
                <IoEyeOutline />
            </div>
            <div className="details">
                <p>Views</p>
                <h4>{data.numberofView}</h4>
            </div>
        </li>
    </ul>
</div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="innerPropertyDetailsList">
                    <div className="container">
                        <div className="innerPropertyDetailsListMain">
                            <div className="propertyDetailsListBox" id="tabBox2">
                                <h3>Basic Details</h3>
                                <ul className="propertyBasicDetails">
                                    {data.propertyOwnership !== '' &&(
                                    <li>
                                        <div className="propertyBasicDetailsCol1">
                                            <p>Ownership</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol2">
                                            <p>:</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol3">
                                            <h4>{data.propertyOwnership}</h4>
                                        </div>
                                    </li>
                                    )}
                                    
                                    <li>
                                        <div className="propertyBasicDetailsCol1">
                                            <p>Plot Facing</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol2">
                                            <p>:</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol3">
                                            <h4>{data.propertyFacing ? data.propertyFacing : "Don't Know"}</h4>
                                        </div>
                                    </li>
                                    
                                    
                                    {data.propertyType !== "Residential Land" && data.propertyType !== "Commercial Building" && data.propertyType  !== "Commercial Land" && data.propertyType  !== "Industrial Land" && data.propertyType  !== "Agricultural Land" &&  (
                                        <>
                                        {data.propertyType !=='Industrial Building' && data.nooffloors!=='' &&(
                                    <li>
                                        <div className="propertyBasicDetailsCol1">
                                            <p>Floor No</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol2">
                                            <p>:</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol3">
                                            <h4>{data.floornumber}</h4>
                                        </div>
                                    </li>
                                        )}
                                        {data.floornumber!=='' &&(
                                    <li>
                                        <div className="propertyBasicDetailsCol1">
                                            <p>No of Floors</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol2">
                                            <p>:</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol3">
                                            <h4>{data.nooffloors}</h4>
                                        </div>
                                    </li>
                                        )}
                                        {data.constructedyear !== '' &&(
                                    <li>
                                        <div className="propertyBasicDetailsCol1">
                                            <p>Constructed Year</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol2">
                                            <p>:</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol3">
                                            <h4>{data.constructedyear}</h4>
                                        </div>
                                    </li>
                                        )}
                                    {data.propertyType  !== 'Commercial Shop' && data.propertyType  !== 'Commercial Office' && data.propertyType  !== 'Commercial Other' && data.propertyType  !== 'Industrial Building' && data.Readytomove!== '' &&(
                                    <li>
                                        <div className="propertyBasicDetailsCol1">
                                            <p>Ready to Move</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol2">
                                            <p>:</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol3">
                                            <h4>{data.Readytomove}</h4>
                                        </div>
                                    </li>
                                    )}
                                    </>
                                    )}
                                    {data.state !== ''&&(
                                    <li>
                                        <div className="propertyBasicDetailsCol1">
                                            <p>State</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol2">
                                            <p>:</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol3">
                                            <h4>{data.state}</h4>
                                        </div>
                                    </li>
                                    )}
                                    {data.district !== ''&&(
                                    <li>
                                        <div className="propertyBasicDetailsCol1">
                                            <p>District</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol2">
                                            <p>:</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol3">
                                            <h4>{data.district}</h4>
                                        </div>
                                    </li>
                                    )}
                                    {data.street !== ''&&(
                                    <li>
                                        <div className="propertyBasicDetailsCol1">
                                            <p>Street</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol2">
                                            <p>:</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol3">
                                            <h4>{data.street}</h4>
                                        </div>
                                    </li>
                                    )}
                                    {data.locality !== ''&&(
                                    <li>
                                        <div className="propertyBasicDetailsCol1">
                                            <p>Locality</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol2">
                                            <p>:</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol3">
                                            <h4>{data.locality}</h4>
                                        </div>
                                    </li>
                                    )}
                                    {data.town !== ''&&(
                                    <li>
                                        <div className="propertyBasicDetailsCol1">
                                            <p>Town</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol2">
                                            <p>:</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol3">
                                            <h4>{data.town}</h4>
                                        </div>
                                    </li>
                                    )}
                                    {data.PropertyAdreess !== ''&&(
                                    <li>
                                        <div className="propertyBasicDetailsCol1">
                                            <p>Address</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol2">
                                            <p>:</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol3">
                                            <h4>{data.PropertyAdreess}</h4>
                                        </div>
                                    </li>
                                    )}
                                    {data.propertyType === 'Commercial Building' && (
                                    <li>
                                        <div className="propertyBasicDetailsCol1">
                                            <p>Near Container access</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol2">
                                            <p>:</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol3">
                                            <h4>{data.Nearby ? data.Nearby : "No"}</h4>
                                        </div> 
                                    </li>
                                    )}
                                    {data.propertyType === 'Commercial Land' && (
                                        <>
                                    <li>
                                        <div className="propertyBasicDetailsCol1">
                                            <p>Near shoping area</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol2">
                                            <p>:</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol3">
                                            <h4>{data.NearShoppingARea ? data.NearShoppingARea : "No"}</h4>
                                        </div> 
                                    </li>
                                    
                                    <li>
                                    <div className="propertyBasicDetailsCol1">
                                        <p>Near residential area</p>
                                    </div>
                                    <div className="propertyBasicDetailsCol2">
                                        <p>:</p>
                                    </div>
                                    <div className="propertyBasicDetailsCol3">
                                        <h4>{data.NearResidenetialArea ? data.NearResidenetialArea : "No"}</h4>
                                    </div> 
                                    </li>

                                    <li>
                                    <div className="propertyBasicDetailsCol1">
                                        <p>Near commercial area</p>
                                    </div>
                                    <div className="propertyBasicDetailsCol2">
                                        <p>:</p>
                                    </div>
                                    <div className="propertyBasicDetailsCol3">
                                        <h4>{data.NearCommercialArea ? data.NearCommercialArea : "No"}</h4>
                                    </div> 
                                    </li>

                                    <li>
                                    <div className="propertyBasicDetailsCol1">
                                        <p>Near tourisum zone</p>
                                    </div>
                                    <div className="propertyBasicDetailsCol2">
                                        <p>:</p>
                                    </div>
                                    <div className="propertyBasicDetailsCol3">
                                        <h4>{data.NearTourismZone ? data.NearTourismZone : "No"}</h4>
                                    </div> 
                                    </li>

                                    <li>
                                    <div className="propertyBasicDetailsCol1">
                                        <p>Near container access</p>
                                    </div>
                                    <div className="propertyBasicDetailsCol2">
                                        <p>:</p>
                                    </div>
                                    <div className="propertyBasicDetailsCol3">
                                        <h4>{data.NearContainerACcess ? data.NearContainerACcess : "No"}</h4>
                                    </div> 
                                    </li>
                                    {data.OtherLocation !== '' &&(
                                    <li>
                                    <div className="propertyBasicDetailsCol1">
                                        <p>Other location</p>
                                    </div>
                                    <div className="propertyBasicDetailsCol2">
                                        <p>:</p>
                                    </div>
                                    <div className="propertyBasicDetailsCol3">
                                        <h4>{data.OtherLocation ? data.OtherLocation : "No Data"}</h4>
                                    </div> 
                                    </li>
                                    )}
                                    </>
                                    )}

                                    {data.propertyType === 'Commercial Shop' && (
                                        <>
                                    <li>
                                        <div className="propertyBasicDetailsCol1">
                                            <p>Within office complex</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol2">
                                            <p>:</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol3">
                                            <h4>{data.CMofficecomplex ? data.CMofficecomplex : "No"}</h4>
                                        </div> 
                                    </li>
                                    <li>
                                        <div className="propertyBasicDetailsCol1">
                                            <p>Within Shopping Mall</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol2">
                                            <p>:</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol3">
                                            <h4>{data.CMShoppingMall ? data.CMShoppingMall : "No"}</h4>
                                        </div> 
                                    </li>
                                    <li>
                                        <div className="propertyBasicDetailsCol1">
                                            <p>Within independent location</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol2">
                                            <p>:</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol3">
                                            <h4>{data.independentlocation ? data.independentlocation : "No"}</h4>
                                        </div> 
                                    </li>
                                    {data.OtherLocation !== '' &&(
                                    <li>
                                        <div className="propertyBasicDetailsCol1">
                                            <p>Other location</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol2">
                                            <p>:</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol3">
                                            <h4>{data.OtherLocation}</h4>
                                        </div> 
                                    </li>
                                    )}
                                        </>
                                    )}

                                {data.propertyType === 'Commercial Office' && (
                                        <>
                                    <li>
                                        <div className="propertyBasicDetailsCol1">
                                            <p>Within office complex</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol2">
                                            <p>:</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol3">
                                            <h4>{data.CMofficecomplex ? data.CMofficecomplex : "No"}</h4>
                                        </div> 
                                    </li>
                                    <li>
                                        <div className="propertyBasicDetailsCol1">
                                            <p>Within independent location</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol2">
                                            <p>:</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol3">
                                            <h4>{data.independentlocation ? data.independentlocation : "No"}</h4>
                                        </div> 
                                    </li>
                                    
                                    {data.OtherLocation !== '' &&(
                                    <li>
                                        <div className="propertyBasicDetailsCol1">
                                            <p>Other location</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol2">
                                            <p>:</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol3">
                                            <h4>{data.OtherLocation}</h4>
                                        </div> 
                                    </li>
                                    )}
                                        </>
                                    )}
                                    {data.propertyType === 'Commercial Other' && (
                                        <>
                                    <li>
                                        <div className="propertyBasicDetailsCol1">
                                            <p>Within office complex</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol2">
                                            <p>:</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol3">
                                            <h4>{data.COFofficecomplex ? data.COFofficecomplex : "No"}</h4>
                                        </div> 
                                    </li>
                                    <li>
                                        <div className="propertyBasicDetailsCol1">
                                            <p>Within independent location</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol2">
                                            <p>:</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol3">
                                            <h4>{data.COFindependentlocation ? data.COFindependentlocation : "No"}</h4>
                                        </div> 
                                    </li>
                                    <li>
                                        <div className="propertyBasicDetailsCol1">
                                            <p>Within container access</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol2">
                                            <p>:</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol3">
                                            <h4>{data.COFcontaineraccess ? data.COFcontaineraccess : "No"}</h4>
                                        </div> 
                                    </li>
                                    
                                    {data.COFOtherlocation !== '' &&(
                                    <li>
                                        <div className="propertyBasicDetailsCol1">
                                            <p>Other location</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol2">
                                            <p>:</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol3">
                                            <h4>{data.COFOtherlocation}</h4>
                                        </div> 
                                    </li>
                                    )}
                                        </>
                                    )}

                                {data.propertyType === 'Industrial Building' && (
                                        <>
                                    <li>
                                        <div className="propertyBasicDetailsCol1">
                                            <p>Within Industrial Belt</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol2">
                                            <p>:</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol3">
                                            <h4>{data.IBIndustrialBelt ? data.IBIndustrialBelt : "No"}</h4>
                                        </div> 
                                    </li>
                                    <li>
                                        <div className="propertyBasicDetailsCol1">
                                            <p>Within Special Zone</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol2">
                                            <p>:</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol3">
                                            <h4>{data.IBSpecialZone ? data.IBSpecialZone : "No"}</h4>
                                        </div> 
                                    </li>
                                    <li>
                                        <div className="propertyBasicDetailsCol1">
                                            <p>Within Commercial Area</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol2">
                                            <p>:</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol3">
                                            <h4>{data.IBCommercialArea ? data.IBCommercialArea : "No"}</h4>
                                        </div> 
                                    </li>
                                    <li>
                                        <div className="propertyBasicDetailsCol1">
                                            <p>Within container Access</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol2">
                                            <p>:</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol3">
                                            <h4>{data.IBcontainerAccess ? data.IBcontainerAccess : "No"}</h4>
                                        </div> 
                                    </li>
                                    
                                    {data.IBotherLocation !== '' &&(
                                    <li>
                                        <div className="propertyBasicDetailsCol1">
                                            <p>Other location</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol2">
                                            <p>:</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol3">
                                            <h4>{data.IBotherLocation}</h4>
                                        </div> 
                                    </li>
                                    )}
                                        </>
                                    )}
                                    {data.propertyType === 'Industrial Land' && (
                                        <>
                                    <li>
                                        <div className="propertyBasicDetailsCol1">
                                            <p>2 Wheeler access</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol2">
                                            <p>:</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol3">
                                            <h4>{data.TwoWheelerAccess ? data.TwoWheelerAccess : "No"}</h4>
                                        </div> 
                                    </li>
                                    <li>
                                        <div className="propertyBasicDetailsCol1">
                                            <p>4 Wheeler access</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol2">
                                            <p>:</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol3">
                                            <h4>{data.FourWheeleraccess ? data.FourWheeleraccess : "No"}</h4>
                                        </div> 
                                    </li>
                                    <li>
                                        <div className="propertyBasicDetailsCol1">
                                            <p>Within Industrial Belt</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol2">
                                            <p>:</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol3">
                                            <h4>{data.withindustrialbelt ? data.withindustrialbelt : "No"}</h4>
                                        </div> 
                                    </li>
                                    <li>
                                        <div className="propertyBasicDetailsCol1">
                                            <p>Within Special Zone</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol2">
                                            <p>:</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol3">
                                            <h4>{data.withspecialzone ? data.withspecialzone : "No"}</h4>
                                        </div> 
                                    </li>

                                    <li>
                                        <div className="propertyBasicDetailsCol1">
                                            <p>Within Commercial Area</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol2">
                                            <p>:</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol3">
                                            <h4>{data.withcommercialrea ? data.withcommercialrea : "No"}</h4>
                                        </div> 
                                    </li>
                                    
                                    {data.otherlocation !== '' &&(
                                    <li>
                                        <div className="propertyBasicDetailsCol1">
                                            <p>Other location</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol2">
                                            <p>:</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol3">
                                            <h4>{data.otherlocation}</h4>
                                        </div> 
                                    </li>
                                    )}
                                        </>
                                    )}

                                    {data.propertyType === 'Residential Land' && (
                                        <>
                                        {data.TwoWheelerAccess !== '' &&(
                                        <li>
                                            <div className="propertyBasicDetailsCol1">
                                                <p>2 Wheeler access</p>
                                            </div>
                                            <div className="propertyBasicDetailsCol2">
                                                <p>:</p>
                                            </div>
                                            <div className="propertyBasicDetailsCol3">
                                                <h4>{data.TwoWheelerAccess ? data.TwoWheelerAccess : "No"}</h4>
                                            </div> 
                                        </li>
                                        )}
                                    {data.FourWheeleraccess !== '' &&(
                                        <li>
                                            <div className="propertyBasicDetailsCol1">
                                                <p>4 Wheeler access</p>
                                            </div>
                                            <div className="propertyBasicDetailsCol2">
                                                <p>:</p>
                                            </div>
                                            <div className="propertyBasicDetailsCol3">
                                                <h4>{data.FourWheeleraccess ? data.FourWheeleraccess : "No"}</h4>
                                            </div> 
                                        </li>
                                    )}

                                    {data.inresidenetialcolony !== '' &&(
                                        <li>
                                            <div className="propertyBasicDetailsCol1">
                                                <p>In residenetial colony</p>
                                            </div>
                                            <div className="propertyBasicDetailsCol2">
                                                <p>:</p>
                                            </div>
                                            <div className="propertyBasicDetailsCol3">
                                                <h4>{data.inresidenetialcolony ? data.inresidenetialcolony : "No"}</h4>
                                            </div> 
                                        </li>
                                    )}
                                    {data.GatedProperty !== '' &&(
                                        <li>
                                            <div className="propertyBasicDetailsCol1">
                                                <p>Gated Property</p>
                                            </div>
                                            <div className="propertyBasicDetailsCol2">
                                                <p>:</p>
                                            </div>
                                            <div className="propertyBasicDetailsCol3">
                                                <h4>{data.GatedProperty ? data.GatedProperty : "No"}</h4>
                                            </div> 
                                        </li>
                                    )}
                                        </>
                                    )}

                                    
                                     

                                {data.propertyType === 'Agricultural Land' && (
                                        <>
                                    <li>
                                        <div className="propertyBasicDetailsCol1">
                                            <p>Usage Status</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol2">
                                            <p>:</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol3">
                                            <h4>{data.UsageSttaus ? data.UsageSttaus : "No Data"}</h4>
                                        </div> 
                                    </li>
                                    <li>
                                        <div className="propertyBasicDetailsCol1">
                                            <p>Agriculture Type</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol2">
                                            <p>:</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol3">
                                            <h4>{data.AgricultureType ? data.AgricultureType : "No Data"}</h4>
                                        </div> 
                                    </li>
                                    {data.Other !== '' &&(
                                    <li>
                                        <div className="propertyBasicDetailsCol1">
                                            <p>Other</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol2">
                                            <p>:</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol3">
                                            <h4>{data.Other ? data.Other : "No Data"}</h4>
                                        </div> 
                                    </li>
                                    )}
                                    <li>
                                        <div className="propertyBasicDetailsCol1">
                                            <p>2 Wheeler access</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol2">
                                            <p>:</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol3">
                                            <h4>{data.IL2wheel ? data.IL2wheel : "No Data"}</h4>
                                        </div> 
                                    </li>

                                    <li>
                                        <div className="propertyBasicDetailsCol1">
                                            <p>4 Wheeler access</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol2">
                                            <p>:</p>
                                        </div>
                                        <div className="propertyBasicDetailsCol3">
                                            <h4>{data.IL4wheel ? data.IL4wheel : "No Data"}</h4>
                                        </div> 
                                    </li>
                                        </>
                                    )}
                                </ul>
                            </div>


                            {amenities && Array.isArray(amenities.data) && amenities.data.length > 0 && (
                                <>
                               
                            <div className="propertyDetailsListBox" id="tabBox3">
                                <h3>Amenities</h3>
                                <ul className="propertyAmenities">
                                {amenities.data.map((item, index) => {
        // Map of amenities and their corresponding display names
        const amenitiesTextMapping = {
          "electricity": "Electricity Backup",
          "lift": "Lift",
          "amenities-holder": "Health club",
          "Club House": "Club House",
          "Swimming Pool": "Swimming Pool",
          "Joggin track": "Jogging Track",
          "Security Services": "Security Services",
          "Laundry Services": "Laundry Service",
          "Servants Bathroom": "Servants Bathroom",
          "Auditorium": "Auditorium",
          "Centralized Gas": "Centralized Gas",
          "Gymnasium": "Gymnasium",
          "Waste Disposal": "Waste Disposal",
          "Shopping Area": "Shopping Area",
          "Water Storage": "Water Storage",
          "Childrens Play area": "Childrens Play area",
          "Visitor Car Parking":"Visitor Car Parking",
          "Reserved Parking": "Reserved Parking",
          "Air Conditioned": "Air Conditioned",
        };

        // Get the display name for the amenity
        const amenityDisplayName = amenitiesTextMapping[item.amenities] || item.amenities;

        return (
          <li key={index}>
            <div className="propertyAmenitiesCol1">
              {/* Dynamically assign icons based on the amenity */}
              {item.amenities === "electricity" && <SlEnergy />}
             
              {item.amenities === "amenities-holder" && <MdOutlineHealthAndSafety />} {/* Default or generic icon */}
              {item.amenities === "Club House" && <TbHealthRecognition />}
            
              {item.amenities === "Joggin track" && <PiPersonSimpleRunBold />}
            
              {item.amenities === "Laundry Services" && <MdOutlineLocalLaundryService />}
              {item.amenities === "Servants Bathroom " && <PiBathtub />}
          
            
              {item.amenities === "Gymnasium" && <CgGym />}
              {item.amenities === "Waste Disposal" && <TbTrash />}
              {item.amenities === "lift" && <GiLift />}
              {item.amenities === "Swimming Pool" && <PiSwimmingPool />}
              {item.amenities === "Security Services" && <GrShieldSecurity />}
              {item.amenities === "Auditorium" && <MdHomeWork />}
              {item.amenities === "Centralized Gas" && <GiGasStove />}
              {item.amenities === "Shopping Area" && <PiShoppingBagOpen />}
              {item.amenities === "Water Storage" && <MdOutlineWaterDrop />}
              {item.amenities === "Childrens Play area" && <TbPlayFootball />}
              
              {item.amenities === "Visitor Car Parking" && <TbParkingCircle />}
              {item.amenities === "Reserved Parking" && <TbParkingCircle />}
              {item.amenities === "Air Conditioned" && <TbAirConditioning />}

            </div>
            <div className="propertyAmenitiesCol2">
              <h4>{amenityDisplayName}</h4>
              <p>Available</p>
            </div>
          </li>
        );
      })}
                                </ul>
                            </div>
                            </>
                            )}
                           {nearby && Object.keys(nearby).length > 0 && nearBy_status === 1 && (
                          
                            <>
                            { console.log(Object.keys(nearby).length)}
                           {console.log(nearBy_status)}
                            <div className="propertyDetailsListBox" id="tabBox4">
                                <h3>Nearby</h3>
                                <ul className="propertyNearby">
                                {nearby.data[0].school !== 0 && (
                                    <>
                                    <li>
                                        <div className="propertyNearbyCol1">
                                            <p>School</p>
                                        </div>
                                        <div className="propertyNearbyCol2">
                                            <h4>{nearby.data[0].school} KM</h4>
                                        </div>
                                    </li>
                                    </>
                                    )}
                                    {nearby.data[0].hospital !== 0 && (
                                    <li>
                                        <div className="propertyNearbyCol1">
                                            <p>Hospital</p>
                                        </div>
                                        <div className="propertyNearbyCol2">
                                            <h4>{nearby.data[0].hospital} KM</h4>
                                        </div>
                                    </li>
                                    )}
                                    {nearby.data[0].busstop !== 0 && (
                                    <li>
                                        <div className="propertyNearbyCol1">
                                            <p>Bus Stop</p>
                                        </div>
                                        <div className="propertyNearbyCol2">
                                            <h4>{nearby.data[0].busstop} KM</h4>
                                        </div>
                                        
                                    </li>
                                    )}
                                    {nearby.data[0].airport !== 0 && (
                                    <li>
                                        <div className="propertyNearbyCol1">
                                            <p>Airport</p>
                                        </div>
                                        <div className="propertyNearbyCol2">
                                            <h4>{nearby.data[0].airport} KM</h4>
                                        </div>
                                    </li>
                                    )}
                                    {nearby.data[0].railway !== 0 && (
                                    <li>
                                        <div className="propertyNearbyCol1">
                                            <p>Railway Station</p>
                                        </div>
                                        <div className="propertyNearbyCol2">
                                            <h4>{nearby.data[0].railway}  KM</h4>
                                        </div>
                                    </li>
                                    )}
                                    {nearby.data[0].supermarket !== 0 && (
                                    <li>
                                        <div className="propertyNearbyCol1">
                                            <p>Super Market</p>
                                        </div>
                                        <div className="propertyNearbyCol2">
                                            <h4>{nearby.data[0].supermarket} KM</h4>
                                        </div>
                                    </li>
                                    )}
                                    {nearby.data[0].atm !== 0 && (
                                    <li>
                                        <div className="propertyNearbyCol1">
                                            <p>ATM</p>
                                        </div>
                                        <div className="propertyNearbyCol2">
                                            <h4>{nearby.data[0].atm} KM</h4>
                                        </div>
                                    </li>
                                    )}
                                    {nearby.data[0].petrolpumb !== 0 && (
                                    <li>
                                        <div className="propertyNearbyCol1">
                                            <p>Petrol Pump</p>
                                        </div>
                                        <div className="propertyNearbyCol2">
                                            <h4>{nearby.data[0].petrolpumb} KM</h4>
                                        </div>
                                    </li>
                                    )}
                                    {nearby.data[0].restaurant !== 0 && (
                                    <li>
                                        <div className="propertyNearbyCol1">
                                            <p>Restaurant</p>
                                        </div>
                                        <div className="propertyNearbyCol2">
                                            <h4>{nearby.data[0].restaurant} KM</h4>
                                        </div>
                                    </li>
                                    )}
                                    {nearby.data[0].shopping !== 0 && (
                                    <li>
                                        <div className="propertyNearbyCol1">
                                            <p>Shopping</p>
                                        </div>
                                        <div className="propertyNearbyCol2">
                                            <h4>{nearby.data[0].shopping} KM</h4>
                                        </div>
                                    </li>
                                    )}
                                    
                                </ul>
                            </div>
                            </>
                    )}
                        </div>
                    
                    </div>
                </div>
                
                {relatedProperties && relatedProperties.length > 0 && (
    <div className="container">
        <div className="relatedProperty">
            <h2 className="title">Related Property</h2>
            <div className="relatedPropertymain">
                <div className="carouselWrapper">
                    {/* Custom Prev Button */}
                    <button className="customNavBtn prev" onClick={goToPrev}>
                        <GoChevronLeft />
                    </button>
                    <OwlCarousel {...settings} ref={carouselRef}>
                        {relatedProperties.map((property) => (
                            <Suspense key={property.propertyId}>
                                <PropertyBox 
                                    propertyLink={`${path}innerProperty/${property.propertyId}/${property.propertyType.replace('/', '').replace(/\s+/g, '-')+"-for-"+property.propertyAction}`}
                                    propertyImage={property.imageName ? "https://keralaplots.com/keralaplots/postProperty/assets/images/PropertyImageLow/"+property.imageName : BASE_URL+''+BASE_URL_NOIMG} 
                                    propertyPurposeTag={property.propertyAction} 
                                    propertyId={property.propertyId}
                                    propertyName={property.propertyType+" For "+property.propertyAction} 
                                    propertyLocation={property.district +' , '+ property.town}
                                    propertyDate={property.addedDate?.split(" ")[0]}
                                    propertyPrice={property.priceVisibility === 'No' ? 'Not disclosed' : property.propertyPricerange} 
                                    propertyType={property.propertyType}
                                    savedStatus={property.savedStatus}
                                />
                            </Suspense>
                        ))}
                    </OwlCarousel>

                    {/* Custom Next Button */}
                    <button className="customNavBtn next" onClick={goToNext}>
                        <GoChevronRight />
                    </button>
                </div>
            </div>
        </div>
    </div>
)}

            </section>
        </>
    );
}

export default InnerProperty;
